exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cc-open-input__2eVRs {\n  min-width: 500px;\n  max-width: 500px;\n}\n\n.cc-close-input__2OGQx {\n  max-width: 500px;\n}\n", ""]);

// Exports
exports.locals = {
	"cc-open-input": "cc-open-input__2eVRs",
	"cc-close-input": "cc-close-input__2OGQx"
};